module.exports = "{{reasons or reason|raw}}\n";
